// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__38Mv1","title":"FrontImage_title__1lUJz"};